import { render, staticRenderFns } from "./messagesType.vue?vue&type=template&id=e1a69d34&"
import script from "./messagesType.vue?vue&type=script&lang=js&"
export * from "./messagesType.vue?vue&type=script&lang=js&"
import style0 from "./messagesType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports